import React from 'react'
import { IconButton } from '@material-ui/core'
import { GRAY_COLORS } from 'asterX-UI'
import ChevronLeftIcon from 'asterX-UI/Icons/ChevronLeftIcon'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '24px',
    gap: 6
  }
}))

const HeaderBack = ({ onClick, children }) => {
  const classes = useStyles()

  return (
    <div className={classes.header}>
      <IconButton
        style={{
          color: GRAY_COLORS[400]
        }}
        onClick={onClick}
        size={'medium'}
      >
        <ChevronLeftIcon />
      </IconButton>

      {children}
    </div>
  )
}
export default HeaderBack
